module.exports = __webpack_public_path__ + "static/media/Ines.af081e88.png";